// update along with app/lib/enums/aws_brand_sync_enum.py
const awsBrandSyncStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
};

const awsBrandSyncStatusOptions = [
  { value: awsBrandSyncStatus.PENDING, label: 'Pending' },
  { value: awsBrandSyncStatus.PROCESSING, label: 'Processing' },
  { value: awsBrandSyncStatus.COMPLETED, label: 'Completed' },
  { value: awsBrandSyncStatus.FAILED, label: 'Failed' },
];

export { awsBrandSyncStatus, awsBrandSyncStatusOptions };
